import SlideNext from './SlideNext'

export default SlideNext
// eslint-disable-next-line import/export
export * from './SlideNext'
